/**
 * 第三方插件配置
 * 包含所有第三方插件的初始化配置
 */

import Vue from "vue";
import ba from 'vue-ba';
import VueLazyload from "vue-lazyload";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Print from "vue-print-nb";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/index.scss"; // global css
import ElementUI from "element-ui";
import tableBodyMixin from "@/components/DsTable/mixins/tableBody";
import VueTianditu from "@/components/Tianditu";

// 初始化所有插件
export function initializePlugins() {
    if(process.env.VUE_APP_ENV === "production") {
        // 百度统计
        Vue.use(ba, "f32fbae25961f11ed8b4c30697150de2");
        Vue.use(ba, { siteId: "f32fbae25961f11ed8b4c30697150de2" });
    }

    Vue.use(VueLazyload, {
        preLoad: 1,
        error: "/static/img/img-error.png",
        loading: "/static/img/img-loading3.gif",
        attempt: 1
    });

    Vue.use(Viewer, {
        defaultOptions: {
            zIndex: 99999999999
        }
    });

    Vue.use(Print);

    const Table = ElementUI.Table;
    // 重置table数据流
    delete Table.components.TableBody.computed.data;
    // 添加虚拟列表逻辑
    Table.components.TableBody.mixins.push(tableBodyMixin);
    Vue.use(ElementUI);

    Vue.use(VueTianditu, {
        v: '4.0',
        tk: process.env.VUE_APP_TIANDITU_TK,
        plugins: ['HeatmapOverlay']
    });
}
